module.exports = ".starBcg path, .starBcg circle {\n  fill: #222222; }\n\n.starBcg {\n  position: absolute;\n  top: 100px;\n  z-index: -10;\n  left: 0;\n  width: 100%; }\n\n#star {\n  width: 3440px;\n  height: auto;\n  position: fixed;\n  top: 0px; }\n\n.lighting {\n  fill: #383838 !important;\n  animation: fadeinout 1s linear forwards; }\n\n@keyframes fadeinout {\n  0%, 100% {\n    opacity: 0; }\n  50% {\n    opacity: 1; } }\n\n#starShape polygon {\n  fill: #222222; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/backgroundStar/backgroundStar.component.scss
// module id = 390
// module chunks = 1